<nk-card class="h-100" andClass="h-100 mb-0" [attr.data-cy]="'company-analysis-bankruptcy-risk-card'">
  <nk-card-header [title]="'company_page.risk_score_card_title' | translate">
    @if (riskScoreAnalysis?.model?.company_risk_score_model_key) {
      <nk-bankruptcy-risk-score-help-info
        [modelKey]="riskScoreAnalysis?.model?.company_risk_score_model_key"></nk-bankruptcy-risk-score-help-info>
    }
  </nk-card-header>
  <nk-card-content andClass="m-0 p-0" type="table">
    @if (companyLifeState$ | async; as companyLifeState) {
      @if (companyLifeState.healthy === false) {
        <nk-company-analysis-company-life-state-card
          [companyUuid]="companyUuid()"
          [companyLifeState]="companyLifeState"></nk-company-analysis-company-life-state-card>
      } @else if (riskScoreAnalysis) {
        <nk-company-analysis-risk-layout
          [bgColor]="companyBankruptsyRiskScoreColor[riskScoreAnalysis.grouping.group_key]"
          [printVersion]="printVersion()">
          <div class="d-flex align-items-top justify-content-between w-100" header>
            <div>
              <h1 class="mb-0" [attr.data-cy]="'company-analysis-bankruptcy-risk-score-value'">
                {{ riskScoreAnalysis.measure.measure_value | percentage }}
                <nk-risk-level-icon
                  [attr.data-cy]="'company-analysis-bankruptcy-risk-score-icon'"
                  [riskLevel]="riskScoreAnalysis.grouping.group_key"
                  class="d-inline-block ms-1 fs-2"></nk-risk-level-icon>
              </h1>
              <p class="mb-0">
                {{ 'company_page.risk_model_grouping_' + riskScoreAnalysis.grouping.group_key | translate }}
                <span class="font-italic">
                  - {{ riskScoreAnalysis.measure.measure_timestamp | date: dateFormats.Standard }}
                </span>
              </p>
            </div>
          </div>
          <div body>
            <p class="text-muted text-uppercase">
              {{ 'bankruptcy_risk_score.risk_score_over_time.title' | translate }}
            </p>
            @if (companyUuid(); as companyUuid) {
              @defer {
                <nk-company-analysis-bankruptcy-risk-chart
                  [companyUuid]="companyUuid"
                  [printVersion]="printVersion()"
                  [riskScoreAnalysisListInput]="prioritizedCompanyRiskScoreAnalysisList">
                </nk-company-analysis-bankruptcy-risk-chart>
              }
            }
          </div>
        </nk-company-analysis-risk-layout>
      } @else {
        @if (loading) {
          <nk-company-analysis-risk-loading
            [text]="'company_page.risk_score_loading' | translate"></nk-company-analysis-risk-loading>
        }
      }
      @if (noCompanyRiskScoreAvailable) {
        <div class="alert alert-warning mt-0 m-3">
          <i class="fa fa-info-circle me-2"></i>
          {{ 'bankruptcy_risk_score.no_bankruptcy_risk_score_available' | translate }}
        </div>
      }
    } @else {
      @if (loading) {
        <nk-company-analysis-risk-loading
          [text]="'company_page.risk_score_loading' | translate"></nk-company-analysis-risk-loading>
      }
    }
  </nk-card-content>
</nk-card>
